module.exports = __webpack_public_path__ + "img/druid_small.f5dcc7c8.png";